import React from 'react';
import { graphql, useFragment } from 'react-relay';
import type { noPermissionViews_projectsDirectoryV3$key } from '@atlassian/jira-relay/src/__generated__/noPermissionViews_projectsDirectoryV3.graphql';
import { NoPermissions } from './no-permissions/index.tsx';
import { NoProjects } from './no-projects/index.tsx';

export interface Props {
	dataRef: noPermissionViews_projectsDirectoryV3$key;
}

export const NoPermissionViews = ({ dataRef }: Props) => {
	const data = useFragment<noPermissionViews_projectsDirectoryV3$key>(
		graphql`
			fragment noPermissionViews_projectsDirectoryV3 on Query {
				...noPermissions_projectsDirectoryV3
				jira {
					canCreateProject: canPerform(type: CREATE_PROJECT, cloudId: $cloudId)
						@optIn(to: "JiraAction")
				}
			}
		`,
		dataRef,
	);

	const canCreateProject = data?.jira?.canCreateProject;

	return data?.jira && canCreateProject ? <NoProjects /> : <NoPermissions dataRef={data} />;
};
